
 <!-- <div class="content-wrapper pt-2"> -->
  <!-- Main content -->
  <section class="content">
   
    <!-- Default box -->
    <div class="card card-info" [ngClass]="{'dark-bg' : isDark }">
      <div class="card-header">Water Meter Reading</div> 
      <form  [formGroup] ="form"  autocomplete="off" (ngSubmit)="saveButtonClick()" class="form-horizontal">
      <fieldset>
      <div class="card-body">

        <div class="row">

        <div class="form-group">
          <input  name="id" readonly formControlName="id"  id="id"  class="form-control"    type="hidden">
          </div>

        <div class="col-md-4">
            <div class="form-group">
            <label for="refCode" class="col-form-label">Ref. Code</label>  
            <div class="input-group">
                <div class="input-group-prepend">
            <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-hashtag"></i></span>
            </div>
            <input   [ngClass]="{'dark-input-field' : isDark }" readonly formControlName="refCode" placeholder="Ref Code"  class="form-control field-bg-color" [class.is-invalid]="formErrors.refCode" (blur)="logValidationErrors()"   type="text">
                </div>
                <span class="text-danger" *ngIf="formErrors.refCode"><small>{{formErrors.refCode}}</small> </span>   
            </div>
          </div>

        <div class="col-md-4">
        <div class="form-group">
            <label for="meterType" class="col-form-label ">Meter Type</label>  
            <div class="input-group">
              <div class="input-group-prepend">
            <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fas fa-user"></i></span>
            </div>
            <select (change)="getAll($event.target.value)" [ngClass]="{'dark-input-field' : isDark }" formControlName="meterType" class="form-control field-bg-color"   [class.is-invalid]="formErrors.meterType" (blur)="logValidationErrors()">        
                <option [ngValue]="null">-Select-</option>
                <option *ngFor="let item of meterType" [value]="item.value">
                  {{item.value}}
                </option>
            </select>
              </div>
              <span class="text-danger" *ngIf="formErrors.meterType"><small>{{formErrors.meterType}}</small> </span>   
        </div>
        </div>  

        <div class="col-md-4">        
            <div class="form-group">
            <label for="consume" class="col-form-label ">Consume</label>  
            <div class="input-group">
              <div class="input-group-prepend">
            <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-envelope"></i></span>
            </div>
            <input readonly  [ngClass]="{'dark-input-field' : isDark }" formControlName="consume" placeholder="Consume"  class="form-control field-bg-color" [class.is-invalid]="formErrors.consume" (blur)="logValidationErrors()"  type="text">
          </div>
          <span class="text-danger" *ngIf="formErrors.consume"><small>{{formErrors.consume}}</small> </span>   
           </div>      
        </div>

    </div>

    
    <div class="row">   
        
        <div class="col-md-4">
          <div class="form-group">
            <label for="fromDate" class="col-form-label ">From Date</label>  
            <div class="input-group">
                <div class="input-group-prepend">
                <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-calendar-o"></i></span>
                </div>
                <input type="text" [ngClass]="{'dark-input-field' : isDark }" bsDatepicker [bsConfig]="datepickerConfig" formControlName="fromDate" class="form-control field-bg-color"  [class.is-invalid]="formErrors.fromDate" (blur)="logValidationErrors()" placeholder="From Date">
            </div>
            <span class="text-danger" *ngIf="formErrors.fromDate"><small>{{formErrors.fromDate}}</small> </span>   
            </div>
         </div>

         <div class="col-md-4">
            <div class="form-group">
                <label for="fromTime" class="col-form-label ">From Time</label>  
                <div class="input-group">
                    <div class="input-group-prepend">
                <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-envelope"></i></span>
                </div>
                <input  name="fromTime" [ngClass]="{'dark-input-field' : isDark }" formControlName="fromTime" placeholder="From Time"  class="form-control" [class.is-invalid]="formErrors.fromTime" (blur)="logValidationErrors()"  type="text">
                </div>
                <span class="text-danger" *ngIf="formErrors.fromTime"><small>{{formErrors.fromTime}}</small> </span>   
            </div>
            </div>

            <div class="col-md-4">        
                <div class="form-group">
                    <label for="firstReading" class="col-form-label ">First Reading</label>  
                    <div class="input-group">
                      <div class="input-group-prepend">
                    <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-envelope"></i></span>
                    </div>
                    <input (keyup)="calculateAmounts()"  [ngClass]="{'dark-input-field' : isDark }" formControlName="firstReading" placeholder="First Reading"  class="form-control" [class.is-invalid]="formErrors.firstReading" (blur)="logValidationErrors()"  type="text">
                  </div>
                  <span class="text-danger" *ngIf="formErrors.firstReading"><small>{{formErrors.firstReading}}</small> </span>   
                   </div>
                </div>
     

    </div>

    <div class="row">  
  
        <div class="col-md-4">
            <div class="form-group">
            <label for="toDate" class="col-form-label ">To Date</label>  
            <div class="input-group">
                <div class="input-group-prepend">
                <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-calendar-o"></i></span>
                </div>
                <input type="text" [ngClass]="{'dark-input-field' : isDark }" bsDatepicker [bsConfig]="datepickerConfig" formControlName="toDate" class="form-control field-bg-color"  [class.is-invalid]="formErrors.toDate" (blur)="logValidationErrors()" placeholder="To Date">
            </div>
            <span class="text-danger" *ngIf="formErrors.toDate"><small>{{formErrors.toDate}}</small> </span>   
            </div>
        </div>
        
        <div class="col-md-4">
            <div class="form-group">
            <label for="toTime" class="col-form-label ">ToTime</label>  
            <div class="input-group">
              <div class="input-group-prepend">
            <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-envelope"></i></span>
            </div>
            <input  name="toTime" [ngClass]="{'dark-input-field' : isDark }" formControlName="toTime" placeholder="To Time" class="form-control" [class.is-invalid]="formErrors.toTime" (blur)="logValidationErrors()"  type="text">
          </div>
          <span class="text-danger" *ngIf="formErrors.toTime"><small>{{formErrors.toTime}}</small> </span>   
           </div>
        </div>

        
        <div class="col-md-4">        
            <div class="form-group">
           <label for="secondReading" class="col-form-label ">Second Reading</label>  
           <div class="input-group">
             <div class="input-group-prepend">
           <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-envelope"></i></span>
           </div>
           <input (keyup)="calculateAmounts()"   [ngClass]="{'dark-input-field' : isDark }" formControlName="secondReading" placeholder="Second Reading"  class="form-control" [class.is-invalid]="formErrors.secondReading" (blur)="logValidationErrors()"  type="text">
         </div>
         <span class="text-danger" *ngIf="formErrors.secondReading"><small>{{formErrors.secondReading}}</small> </span>   
          </div>
          </div>

    </div>


      </div>                                
      <!-- /.card-body -->
      <div class="card-footer">
        <button type="button" (click)="newButtonClick()" class="btn btn-success ml-2">New</button>

        <button *ngIf="crud_access.create"  type="submit" [disabled]="isSaveBtnDisabled" class="btn btn-primary ml-2">
          <span *ngIf ="showProcessingIndicator" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          Save
        </button>

        <button class="btn btn-primary ml-2" routerLink="../water-meter-list"><i class="fa fa-table p-1"></i>Water Meter List</button>
        <button  type="button"  *ngIf ="isShowAttachBtn" class="btn btn-primary ml-2" (click)="attachFileButtonClick()"><i class="fa fa-plus p-1"></i>Attach Files</button>        
      </div>
      <!-- /.card-footer-->
    </fieldset>
      </form>
    </div>
  </section>
    <!-- </div> -->


    <!-- Form Values : {{ addCustomerForm.value | json }} -->
  
